module.exports = __webpack_public_path__ + "static/media/logo_coopbank.f545c1c3.svg";